export default "__VITE_ASSET__C6pGJL$L__"